import { Box } from '@creditas-ui/layout';
import { ButtonSecondary } from '@creditas-ui/button';
import { styled } from '@creditas-ui/system';

const Logout = styled(Box)`
  padding-top: 24px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  margin-top: 40px;
  display: flex;
  align-items: center;
`;

const LogoutButton = styled(ButtonSecondary)`
  margin-left: 10px;
`;

export { Logout, LogoutButton };
